import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

function PageHeader({
  title,
  buttonText,
  buttonLink,
  handelClick,
  hideAddButton = false,
}) {
  const navigate = useNavigate();

  const buttonClick = () => {
    if (buttonLink) {
      navigate(buttonLink);
    } else {
      handelClick();
    }
  };
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ marginBottom: '36px' }}
    >
      <Typography component="h1" variant="h1">
        {title}
      </Typography>
      {!hideAddButton && (
        <Button variant="main" onClick={() => buttonClick()}>
          <Stack direction="row" alignItems="center" columnGap="12px">
            <Typography fontWeight="700">+</Typography>
            <Typography fontWeight="700">{buttonText}</Typography>
          </Stack>
        </Button>
      )}
    </Stack>
  );
}

export default PageHeader;
